export class Params {
    public Id: number;
    public CompanyId: number;
    public ViewsId: number;
    public ParamsId: number;
    public Descrip: string;
    public Order: number;
    public Visibility: boolean;
    public Display: boolean;
    public Text: string;
    public Name: string;
}
